import React from 'react';

export function TableSkeleton({ rows = 6, cols = 5 }) {
  return (
    <div className="p-4 space-y-2" data-testid="table-skeleton">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="grid gap-3" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
          {Array.from({ length: cols }).map((__, c) => (
            <div key={c} className="h-6 rounded shimmer" />
          ))}
        </div>
      ))}
    </div>
  );
}

export function CardSkeleton({ height = 100 }) {
  return <div className="rounded-lg shimmer" style={{ height }} />;
}
